<template>
  <div class="questionsContainer">
    <div class="w-full h-[4vw]">
      <img src="../assets/icons/spacecraftIcon.svg" alt="Kaffea Terra spacecraft"
           class="w-[10vw] relative left-[10%]">
    </div>
    <div class="title">
      <p>{{ $t('questionPage.title') }}</p>
      <p>{{ $t('questionPage.question') }}</p>
    </div>
    <div class="flex flex-col gap-[3vw] w-full">
      <button
          :class="{ selected: isSelected('Αμερική') }"
          @click="selectAnswer('Αμερική')"
      >
        {{ $t('questionPage.firstAnswer') }}
      </button>
      <button
          :class="{ selected: isSelected('Αφρική') }"
          @click="selectAnswer('Αφρική')"
      >
        {{ $t('questionPage.secondAnswer') }}
      </button>
      <button
          :class="{ selected: isSelected('Ασία') }"
          @click="selectAnswer('Ασία')"
      >
        {{ $t('questionPage.thirdAnswer') }}
      </button>
    </div>

    <div class="w-full flex flex-row justify-between">
      <img src="../assets/icons/dotIcon.svg" alt="Kaffea Terra star" class="w-[1vw] relative left-[10%]">
      <img src="../assets/icons/movingstarIcon.svg" alt="Kaffea Terra moving star" class="w-[12vw]">
    </div>
  </div>

  <div class="flex justify-end gap-[1vw] absolute bottom-0 w-full">
    <div @click="goToPreviousQuestion">
      <img src="@/assets/arrowleft.svg" alt="arrow-left" class="w-[5vw] h-[5vw]">
    </div>
    <div @click="handleSubmit">
      <img src="@/assets/arrowright.svg" alt="arrow-right" class="w-[5vw] h-[5vw]">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    answers: Object,
  },
  data() {
    return {
      answer: this.answers.question1 || "",
    };
  },
  methods: {
    selectAnswer(selectedAnswer) {
      this.answer = selectedAnswer;
      this.$emit("update-answers", {question1: this.answer});

      this.handleSubmit();
    },

    isSelected(option) {
      return this.answer === option;
    },

    goToPreviousQuestion() {
      this.$emit("prev-step");
    },

    handleSubmit() {
      if (this.answer) {
        this.$emit("next-step");
      }
    },
  },
};
</script>


<style scoped>
.questionsContainer {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 60px;
  overflow: hidden;
  padding-bottom: 15%;

  @media only screen and (max-width: 1000px) {
    gap: 50px;
  }
  @media only screen and (max-width: 750px) {
    gap: 30px;
  }
}

.title {
  text-align: center;
  font-size: 7vw;
  line-height: normal;
  color: #FFFFFF;
  text-transform: uppercase;
}

button {
  padding: 5px 40px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  background: #434B78;
  border: 1px solid #FFFFFF;
  border-radius: 99px;
  color: #FFFFFF;
  text-transform: uppercase;
  text-align: center;
  font-size: 5vw;
  line-height: normal;
}

button:hover {
  background-color: white;
  color: #101B53;
}

button.selected {
  background-color: white;
  color: #101B53;
  font-weight: bold;
  border-color: #101B53;
}
</style>
